import { render, staticRenderFns } from "./product-tariffs.vue?vue&type=template&id=04c8f102&"
import script from "./product-tariffs.vue?vue&type=script&lang=js&"
export * from "./product-tariffs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports